import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function headerTopItems() {
  const widgetName = 'headerTopItems';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof headerTopItemsOpts === 'undefined' ? null : headerTopItemsOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 5,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createHeaderTopItems(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createHeaderTopItems(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $item = $(this);

      if (URL == null) {
        $item.remove();
      } else {
        $item.replaceWith(
          `<a class="header-top-item"  href="${URL}" ${updateLinksAttributes(URL, Title)} >${Title}</a>`,
        );
      }
    });
  }
}
